module.exports = __webpack_public_path__ + "img/en-2-t.ce889006.png";